import React, { useState, useCallback, useEffect } from "react";
import { Link } from "react-router-dom";
import Footer from "../Footer";
import HeroImage from "../HeroImage";
import PiSearchResult from "../PiSearchResult";
import Select from "../../forms/Select";
import StaticConfig from "../StaticConfig";
import { validateField } from "../../pages/functions";
import imgHeaderDocumentSearchMobile from "../assets/img_header_document_search_mobile.jpg";
import imgHeaderDocumentSearch from "../assets/img_header_document_search.jpg";
import "./styles.css";
import { api } from "../index.api";
import connect from "react-redux/es/connect/connect";
import {
  ABBVIE_EMPLOYEE,
  HCP,
  PATIENT,
  REF_DATA,
  DOWNLOAD_BUTTON,
  NO_NAME_DISPLAYED,
  USER_SCOPE,
} from "../../constants";
import { getCookie } from "../../helpers/CookieHandler";
import { addNotification as notify } from "reapop";
import { triggerSSO } from "../InitiateSSO";
import { auditSearch } from "../Audit";
import { v4 as uuidv4 } from "uuid";
import PaginatedDocumentsTable from "../tables/PaginatedDocumentsTable";

const Allergen = (props) => {
  const showNotification = (title, message, status) => {
    props.notify({
      title,
      message,
      status,
      position: "tr",
      dismissible: true,
      dismissAfter: 3000,
    });
  };
  let widthQuery = window.matchMedia("(min-width: 576px)");
  const columnKeys = [
    {
      key: "name__v",
      style: { fontWeight: "bold" },
      width: "60%",
    },
    {
      key: "gmi_approval_date__c",
      style: { whiteSpace: "nowrap" },
      width: "15%",
    },
    {
      key: "language__v",
      isArray: true,
      width: "10%",
    },
    {
      key: DOWNLOAD_BUTTON,
      style: { textAlign: "right" },
      width: "15%",
    },
  ];

  const [columnNames, setColumnNames] = useState([]);
  const pageContent =
    StaticConfig.Context.UserType === "PATIENT"
      ? props.pageContent.content.module.allergen.allergenPatient
      : props.pageContent.content.module.allergen;
  const [tableContainerStyle, setTableContainerStyle] = useState({});
  const [PISearchURL, setPISearchURL] = useState("");
  const [searchPerformed, setSearchPerformed] = useState(false);

  const selectedCountry = getCookie("selectedEmployeeCountryLabel");
  const [fields, setFields] = useState({
    product: {
      name: "Product",
      value: "",
      rules: { title: "Product", required: true },
    },
  });

  const validate = useCallback(
    (e, field) => {
      const validateFields = validateField(e, field, fields);
      setFields({ ...validateFields });
    },
    [fields]
  );

  const [productOptions, setProductOptions] = useState([]);
  const [properties, setProperties] = useState({
    searchItems: [],
    searching: false,
    searchedProductCode: null,
    searchPerformed: false,
    searchAuditId: null,
    searchId: uuidv4(),
    searchUserType: "",
    showModal: false,
    showMobileVersion: !widthQuery.matches,
  });

  useEffect(() => {
    const products = props.referenceData.ProductMaster;
    if (products) {
      if (StaticConfig.Context.UserType === HCP) {
        setProductOptions(
          products
            .filter((product) => product.availableForAllergen)
            .map((product) => ({
              value: product.veevaProductCode,
              label: product.name,
            }))
        );
      } else if (StaticConfig.Context.UserType === ABBVIE_EMPLOYEE) {
        setProductOptions(
          products
            .filter((product) => product.availableForAllergenEmployee)
            .map((product) => ({
              value: product.veevaProductCode,
              label: product.name,
            }))
        );
      } else if (StaticConfig.Context.UserType === PATIENT) {
        setProductOptions(
          products
            .filter((product) => product.availableForAllergenPatient)
            .map((product) => ({
              value: product.veevaProductCode,
              label: product.name,
            }))
        );
      }
    }
  }, [props.referenceData, StaticConfig.Context.UserType]);

  useEffect(() => {
    // const searchContent = props.pageContent.content.module.searchDocument;
    setTableContainerStyle(
      properties.showMobileVersion ? { marginBottom: "0px" } : {}
    );
    setColumnNames([
      pageContent.documentTitle,
      pageContent.effectiveDate,
      pageContent.language,
      NO_NAME_DISPLAYED,
    ]);
  }, [properties, props.pageContent]);

  const piSearchResult = (productValue) => {
    const matchedProduct = findSearchedProduct(productValue);
    const piSearchLinks = matchedProduct ? matchedProduct.piSearchLinks : "";
    setPISearchURL(piSearchLinks);
  };

  const handleSearch = useCallback(() => {
    const payload = {
      product: fields.product.value,
      category: "",
      keywords: "",
      country: selectedCountry,
      searchUserType: StaticConfig.Context.UserType,
      type: "Allergen",
    };
    if (StaticConfig.Context.UserType === "PATIENT") {
      api.searchPatientDocuments(
        payload,
        (response) => searchSuccessHandler(response, payload),
        searchFailureHanlder
      );
    } else {
      api.searchDocuments(
        payload,
        (response) => searchSuccessHandler(response, payload),
        searchFailureHanlder
      );
    }
  }, []);

  const searchSuccessHandler = (response, payload) => {
    if (response.status === 200) {
      response.json().then((responseJson) => {
        setProperties((prevProperties) => ({
          ...prevProperties,
          searching: false,
          searchPerformed: true,
          searchItems: responseJson,
          searchId: uuidv4(),
          searchedProductCode: payload.product,
        }));
        piSearchResult(payload.product);
        setSearchPerformed(true);
        auditSearchEvent(payload, responseJson);
      });
    } else if (response.status === 401) {
      showNotification(
        "Error",
        "You are not authorized to perform this action. Please log in again.",
        "error"
      );
      setTimeout(() => triggerSSO(props.pageContent.content.lang), 3000);
    } else {
      showNotification(
        "Error",
        "Error occurred while submitting query",
        "error"
      );
    }
  };

  const searchFailureHanlder = () => {
    showNotification("Error", "Error occurred while submitting query", "error");
  };

  const auditSearchEvent = (data, result) => {
    const productDetails = findSearchedProduct(data.product);
    const keywords = data.keywords;

    // extract Allergen_Search_Topics from ApplicationConfig (array of objects)
    let topic = "";
    try {
      const appConfig =
        props.referenceData && props.referenceData.ApplicationConfig;
      if (Array.isArray(appConfig)) {
        const found = appConfig.find(
          (cfg) =>
            cfg &&
            cfg.Allergen_Search_Topics !== undefined &&
            cfg.Allergen_Search_Topics !== null
        );
        if (found) topic = found.Allergen_Search_Topics || "";
      }
    } catch (err) {
      topic = "";
    }

    const searchCriteria = {
      productName: productDetails.name,
      category: data.category,
      country: data.country,
      scope: USER_SCOPE[StaticConfig.Context.UserType],
      keyword: keywords,
      topic: topic,
    };

    auditSearch(searchCriteria, result, setSearchAuditId);
  };
  const setSearchAuditId = (searchAuditIdParams) => {
    setProperties((prevProperties) => ({
      ...prevProperties,
      searchAuditId: searchAuditIdParams,
    }));
  };

  const findSearchedProduct = (productValue) => {
    let matchedProduct = {};

    if (props.referenceData != null) {
      matchedProduct = props.referenceData.ProductMaster.find(
        (p) => p.veevaProductCode === productValue
      );
    }

    return matchedProduct;
  };

  return (
    <div className="page-container">
      <div className="page-content">
        <HeroImage
          title={pageContent.title}
          imageDesktop={imgHeaderDocumentSearch}
          imageMobile={imgHeaderDocumentSearchMobile}
        />
        <div className="container">
          <div className="row mb-5">
            <p>{pageContent.header}</p> <br />
            <div>
              <p>{pageContent.contactInfoHeader}</p>
              {pageContent.phoneNumber && (
                <div
                  style={{
                    display: "block",
                    marginBottom: "10px",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-telephone-fill"
                    viewBox="0 0 16 16"
                    style={{ verticalAlign: "middle", marginRight: "5px" }}
                  >
                    <path
                      fillRule="evenodd"
                      d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"
                    />
                  </svg>
                  <a
                    data-tag="track-link"
                    data-analytics-text="Contact Abbvie"
                    href={`tel:${pageContent.phoneNumber.replace(/\D/g, "")}`}
                    style={{ verticalAlign: "middle", marginRight: "5px" }}
                  >
                    {pageContent.phoneNumber}
                  </a>
                </div>
              )}
              {pageContent.urlName && (
                <div
                  style={{
                    display: "block",
                    marginBottom: "10px",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-pencil-square"
                    viewBox="0 0 16 16"
                    style={{ verticalAlign: "middle", marginRight: "5px" }}
                  >
                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                    <path
                      fillRule="evenodd"
                      d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                    />
                  </svg>
                  <Link
                    className="submit-inquiry-link"
                    data-tag="track-link"
                    data-analytics-text="Submit Inquiry"
                    to="/submit-inquiry"
                    style={{ verticalAlign: "middle", marginRight: "5px" }}
                  >
                    {pageContent.urlName}
                  </Link>
                </div>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <Select
                searchable
                clearable={false}
                options={productOptions}
                field={fields.product}
                validate={(e) => validate(e, fields.product)}
                // onChange={(e) => {
                //   handleProductChange(e);
                // }}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <button
                className="btn btn-lg btn-info btn-rounded save_button"
                onClick={handleSearch}
                style={{ marginTop: "10px" }}
                disabled={!fields.product.value}
              >
                {pageContent.search}
              </button>
            </div>
          </div>
          {properties.searchItems.length === 0 && searchPerformed && (
            <div style={{ maxWidth: "650px", marginTop: "1rem" }}>
              <div className="warning-message">
                <i className="fa fa-times-circle" />
                {pageContent.noDocumentsFound}
              </div>
            </div>
          )}
          {searchPerformed && (
            <div className="row mt-5">
              <div className="col widget-mb-0-row prescribing-info">
                <PiSearchResult
                  searchUserType={StaticConfig.Context.UserType}
                  piSearchLinks={PISearchURL}
                  lang={pageContent}
                  language={props.pageContent.content.lang}
                />
              </div>
            </div>
          )}
          <div className="row mt-5">
            <div
              className="container"
              style={{ marginTop: "0px", ...tableContainerStyle }}
            >
              {properties.searchItems.length > 0 && (
                <div className="mobile-background">
                  <div className="mobile-padding">
                    <PaginatedDocumentsTable
                      // Key forces pagination component to reset state when search result changes
                      key={properties.searchId}
                      id="search-documentation"
                      results={properties.searchItems}
                      searchedProductCode={properties.searchedProductCode}
                      columnNames={columnNames}
                      columnKeys={columnKeys}
                      searchAuditId={properties.searchAuditId}
                      showMobileVersion={properties.showMobileVersion}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
          {properties.searchItems.length > 0 && (
            <div>
              <p style={{ marginBottom: "10px" }}>{pageContent.disclaimerPI}</p>
              <b>{pageContent.disclaimerDocSearchBold}</b>{" "}
              {pageContent.disclaimerDocSearch}
            </div>
          )}
        </div>
        <Footer submitInquiry={false} showHomeFooter={false} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  referenceData: state.referenceData.find(
    (category) => category.type === REF_DATA
  ).referenceData,
  pageContent: state.pageContent,
});

export default connect(mapStateToProps, { notify })(Allergen);



// WEBPACK FOOTER //
// ./src/mi-app/allergen/allergen.js